import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { JOB_STATUS, type Job, type JobStatus, type Paginated } from '@worksy360/shared';
import { api } from '../lib/api.js';
import { Badge, Card, EmptyState, Skeleton } from '../ui/index.js';
import { label, relTime, statusTone } from '../lib/format.js';

export function JobsList() {
  const [status, setStatus] = useState<JobStatus>('needs_scheduling');
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ['jobs', status],
    queryFn: () => api.get<Paginated<Job>>(`/jobs?status=${status}`),
  });
  const jobs = data?.items ?? [];

  return (
    <>
      <div className="page-head"><div><div className="page-title">Jobs</div><div className="page-sub">Work orders by status</div></div></div>
      <div className="row gap-2 wrap" style={{ marginBottom: 'var(--sp-4)' }}>
        {JOB_STATUS.map((s) => (
          <button key={s} className={`btn ${s === status ? 'btn-primary' : 'btn-secondary'} btn-sm`} onClick={() => setStatus(s)}>{label(s)}</button>
        ))}
      </div>
      <Card>
        {isLoading ? (
          <div className="card-pad stack gap-3">{[0, 1, 2].map((i) => <Skeleton key={i} h={22} />)}</div>
        ) : jobs.length === 0 ? (
          <EmptyState icon="✍" title={`No ${label(status).toLowerCase()} jobs`}>Jobs in this status will show up here.</EmptyState>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>Job</th><th>Title</th><th>Priority</th><th>Updated</th></tr></thead>
              <tbody>
                {jobs.map((j) => (
                  <tr key={j.id} onClick={() => navigate(`/customers/${j.customerId}`)}>
                    <td><strong>{j.number}</strong></td>
                    <td>{j.title}</td>
                    <td><Badge tone={statusTone(j.priority)}>{label(j.priority)}</Badge></td>
                    <td className="muted">{relTime(j.updatedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
